module.exports = __webpack_public_path__ + "static/media/040.cb20b11e.jpg";